import { isPhotoMessage, sanitizeInput } from '../../utils/utils';

import FileMessage from './Messages/FileMessage';
import ImageMessage from './Messages/ImageMessage';
import React from 'react';
import TextMessage from './Messages/TextMessage';
import { getMessageTime } from '../../utils/time';

interface MessageProps {
  id: number;
  direction: string;
  created: string;
  msg: string;
  error?: boolean;
  isEncrypted?: boolean;
  isKeyExchange?: boolean;
  senderUsername?: string;
  isUnverified?: boolean;
  isSatellite?: boolean;
  lat?: string;
  lng?: string;
}

const Message = React.memo(
  ({ id, direction, created, msg, error, isEncrypted, isKeyExchange, senderUsername, isUnverified, isSatellite, lat, lng }: MessageProps) => {
  const { time } = getMessageTime(created);

  // Media message
  if (isPhotoMessage(msg)) {
    const msgJson = JSON.parse(msg);
    if (String(msgJson.dtype) === '11') {
      // Image
      const image = {
        msg: msgJson.msg,
        media: msgJson.media,
        fname:
          msgJson.fname && String(msgJson.fname).length > 0
            ? `${sanitizeInput(msgJson.fname)}`
            : 'weblinq_photo.webp',
        dname:
          msgJson.fname && String(msgJson.fname).length > 0
            ? `${sanitizeInput(msgJson.fname)}`
            : 'weblinq_photo.webp',
        time: time,
        lat:
          msgJson.lat !== undefined ? parseFloat(msgJson.lat).toFixed(6) : null,
        lng:
          msgJson.lng !== undefined ? parseFloat(msgJson.lng).toFixed(6) : null,
      };

      return (
        <ImageMessage
          key={id}
          id={id}
          direction={direction}
          created={created}
          image={image}
          error={error}
        />
      );
    } else if (String(msgJson.dtype) === '12') {
      const sanitizedFname = sanitizeInput(msgJson.fname);
      const file = {
        media: msgJson.media,
        msg: msgJson.msg,
        time: time,
        fname: sanitizedFname,
        dname:
          msgJson.fname && msgJson.fname.length > 0
            ? `${sanitizedFname}`
            : 'weblinq_file.txt',
        lat:
          msgJson.lat !== undefined ? parseFloat(msgJson.lat).toFixed(6) : null,
        lng:
          msgJson.lng !== undefined ? parseFloat(msgJson.lng).toFixed(6) : null,
      };

      return (
        <FileMessage
          key={id}
          id={id}
          direction={direction}
          created={created}
          file={file}
          dkb={msgJson.dkb}
          error={error}
        />
      );
    }
  }

  return (
    <TextMessage
      key={id}
      id={id}
      direction={direction}
      created={created}
      msg={msg}
      error={error}
      isEncrypted={isEncrypted}
      isKeyExchange={isKeyExchange}
      senderUsername={senderUsername}
      isUnverified={isUnverified}
      isSatellite={isSatellite}
      lat={lat}
      lng={lng}
    />
  );
});

export default Message;
